<!-- @format -->

@for (node of nodes; track node) {
  @if (node.type === "CourseUnit") {
    <div class="tree-list-body">
      <div class="row">
        <div class="col-sm-6 tree-list-body-inner">
          <sis-plan-course-unit
            [courseUnit]="this.planData.courseUnitsById[node.courseUnitId]"
            [planStateObject]="planStateObject"
            [planData]="planData">
          </sis-plan-course-unit>
        </div>
      </div>
    </div>
  }
  @if (node.type === "Module") {
    <sis-plan-module
      [module]="this.planData.modulesById[node.moduleId]"
      [planStateObject]="planStateObject"
      [planData]="planData"
      [uiStateObject]="uiStateObject"
      [level]="level + 1">
    </sis-plan-module>
  }
  @if (node.type === "CustomCourseUnitAttainment") {
    <div class="tree-list-body">
      @let attainment = planData.attainmentsById[node.customCourseUnitAttainmentId];
      @if (isCustomCourseUnitAttainment(attainment)) {
        <div class="row">
          <div class="col-sm-6 tree-list-body-inner">
            <sis-plan-custom-course-unit-attainment [customCourseUnitAttainment]="attainment" [planStateObject]="planStateObject">
            </sis-plan-custom-course-unit-attainment>
          </div>
        </div>
      }
    </div>
  }
  @if (node.type === "CustomModuleAttainment") {
    @let attainment = planData.attainmentsById[node.customModuleAttainmentId];
    @if (isCustomModuleAttainment(attainment)) {
      <sis-plan-custom-module-attainment
        [customModuleAttainment]="attainment"
        [planStateObject]="planStateObject"
        [planData]="planData"
        [uiStateObject]="uiStateObject"
        [level]="level + 1">
      </sis-plan-custom-module-attainment>
    }
  }
  @if (node.type === "AttainmentGroupNode") {
    <sis-attainment-group-node
      [attainmentGroupNode]="node"
      [planStateObject]="planStateObject"
      [planData]="planData"
      [uiStateObject]="uiStateObject"
      [level]="level + 1">
    </sis-attainment-group-node>
  }
}
